{
  "active": "Aktiv",
  "added": "Lagt inn",
  "address": "Adresse",
  "category": "Kategori",
  "city": "Poststad",
  "contactPerson": "Kontaktperson",
  "contactStatus": "Kontaktstatus",
  "deactivatedDate": "Utmeld",
  "description": "Beskriving",
  "dueDate": "Forfallsdato",
  "email": "E-post",
  "endDate": "Sluttdato",
  "ended": "Slutta",
  "establishedDate": "Etableringsdato",
  "eventDate": "Eventdato",
  "eventName": "Eventnavn",
  "firstName": "Fornamn",
  "focusArea": "Fokusområde",
  "focusAreas": "Fokusområde",
  "gender": "Kjønn",
  "hourRate": "Timesats",
  "hours": "Timar",
  "id": "ID",
  "inkind": "Eigeninnsats",
  "inkindStatus": "Eigeninnsatsstatus",
  "interestAreas": "Interesseområde",
  "international": "Internasjonal",
  "invitationStatus": "Invitasjonsstatus",
  "lastName": "Etternamn",
  "lastChangedDate": "Sist endra",
  "mainContact": "Hovudkontakt",
  "mainContactEmail": "Hovedkontakt epost",
  "mainGoal": "Hovudmål",
  "markAllRows": "Merk alle rader",
  "markRow": "Merk rad {{index}}",
  "member": "Medlem",
  "memberCompany": "Medlemsbedrift",
  "memberSince": "Medlem sida",
  "name": "Namn",
  "numberOfEmployees": "Antal ansette",
  "numberOfParticipants": "Antal deltakarar",
  "organizationNumber": "Organisasjonsnummer",
  "participants": "Deltagere",
  "phase": "Fase",
  "phone": "Telefon",
  "postalCode": "Postkode",
  "projectLeader": "Prosjektleiar",
  "projectName": "Prosjektnavn",
  "resourceBaseContact": "Kontakt i ressursbasen",
  "responsible": "Ansvarleg",
  "retired": "Utmeld",
  "retiredDate": "Utmeld dato",
  "roles": "Roller",
  "selfEffort": "Eigeninnsats",
  "selfEffortStatus": "Eigeninnsats status",
  "source": "Kjelde",
  "startDate": "Startdato",
  "status": "Status",
  "subProject": "Delprosjekt",
  "type": "Type",
  "company": "Bedrift",
  "export": "Eksport",
  "title": "Tittel",
  "submittedDate": "Innsendt dato",
  "municipality": "Kommune",
  "customerName": "Kundenamn",
  "rowCannotBeMarked": "Denne rada kan ikkje bli valt",
  "year": "År",
  "fileName": "Filnamn",
  "download": "Last ned",
  "numericId": "ID",
  "companyName": "Bedrift",
  "fromDate": "Opptaksdato",
  "ideaName": "Idénamn",
  "registrationDate": "Registreringsdato",
  "preInkFunds": "Preinkubasjon",
  "otherFunds": "Øvrige faser",
  "totalFunds": "Total sum",
  "admissionDate": "Opptaksdato",
  "portfolioIndustries": "Bransjer",
  "organizationName": "Bedriftsnamn",
  "serviceName": "Tjenestenamn",
  "actor": "Aktør",
  "deliveredServices": "Leverte tenester",
  "contactEmail": "Kontaktperson e-post",
  "industry": "Bransje",
  "invoiceDate": "Fakturadato",
  "clusterMemberName": "Navn",
  "clusterMemberOrgNo": "Org nr.",
  "services": "Tenester",
  "registeredRecommended": "Registrert anbefalt",
  "dateRecommended": "Dato anbefalt",
  "registeredDelivered": "Registrert levert",
  "dateDelivered": "Dato levert",
  "recommendedStatus": "Anbefalt status",
  "deliveredStatus": "Levert status",
  "sendRecommendation": "Send anbefaling",
  "markAsRecommended": "Marker som anbefalt",
  "markAsDelivered": "Marker som levert",
  "deliveryTypes": "Leveransetypar",
  "workGroup": "Arbeidsgruppe"
}
